import { render, staticRenderFns } from "./rcptCompMassCard.vue?vue&type=template&id=75c12583&scoped=true"
import script from "./rcptCompMassCard.vue?vue&type=script&lang=js"
export * from "./rcptCompMassCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c12583",
  null
  
)

export default component.exports